import { render, staticRenderFns } from "./HistoricalFailure.vue?vue&type=template&id=10f881e6&scoped=true"
import script from "./HistoricalFailure.vue?vue&type=script&lang=js"
export * from "./HistoricalFailure.vue?vue&type=script&lang=js"
import style0 from "./HistoricalFailure.vue?vue&type=style&index=0&id=10f881e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f881e6",
  null
  
)

export default component.exports